module.exports = "/packs/media/images/icons/ClaimwithSpouse-3e6a11fe4d78088586e90093cb157852.png";